export default __webpack_public_path__ + "static/media/logo.426d7340.svg";